import { render, staticRenderFns } from "./right_2.vue?vue&type=template&id=c150e254&scoped=true&"
import script from "./right_2.vue?vue&type=script&lang=js&"
export * from "./right_2.vue?vue&type=script&lang=js&"
import style0 from "./right_2.vue?vue&type=style&index=0&id=c150e254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c150e254",
  null
  
)

export default component.exports